import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ruta-modulo',
  templateUrl: './ruta-modulo.component.html',
  styleUrls: ['./ruta-modulo.component.css']
})
export class RutaModuloComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
